import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Nav = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const go = (id) => { setOpen(false); const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: "smooth" }); };
  const goInsights = () => { setOpen(false); navigate("/insights"); };
  return (
    <nav className={`pb-nav ${scrolled ? "scrolled" : ""}`} aria-label="Main navigation">
      <div className="nav-inner">
        <button className="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          Mortgage Survival Playbook 2026
        </button>
        <button
          className="nav-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
        <div className={`nav-links ${open ? "open" : ""}`}>
          <button className="nav-link" onClick={() => go("framework")}>Framework</button>
          <button className="nav-link" onClick={() => go("included")}>What's Included</button>
          <button className="nav-link" onClick={() => go("implementation")}>90-Day Implementation</button>
          <button className="nav-link" onClick={() => go("business")}>Business Case</button>
          <button className="nav-link" onClick={() => go("market")}>Market Data</button>
          <button className="nav-link" onClick={goInsights} data-testid="nav-insights-link">Insights</button>
          <button className="nav-link" onClick={() => go("preview")}>Preview</button>
          <button className="nav-link nav-buy" onClick={() => go("purchase")}>Acquire License</button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
